(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dk-serie"] && !Shopify.designMode) return;
  try {
    (function () {
    function addShopAll() {
      var map = {};
      document.querySelectorAll('a.menu-list__link[href]').forEach(function (a) {
        var t = (a.textContent || '').trim();
        if (t) map[t] = a.getAttribute('href');
      });
      document.querySelectorAll('.menu-drawer__menu--childlist').forEach(function (ul) {
        if (ul.querySelector('.dk-shopall-m')) return;
        var wrap = ul.closest('.menu-drawer__inner-submenu');
        var titleLink = wrap && wrap.querySelector('a.menu-drawer__title[href]');
        var holder = ul.closest('details');
        var label = holder && holder.querySelector('.menu-drawer__menu-item--mainlist .menu-drawer__menu-item-text');
        var title = ((label || titleLink || {}).textContent || '').trim();
        var href = map[title] || (titleLink && titleLink.getAttribute('href'));
        if (!title || !href || href === '#') return;
        var li = document.createElement('li');
        li.className = 'menu-drawer__list-item dk-shopall-m';
        var a = document.createElement('a');
        a.href = href;
        a.className = 'menu-drawer__menu-item menu-drawer__menu-item--parent';
        a.style.fontWeight = '600';
        a.textContent = 'Shop alle ' + title.toLowerCase() + ' →';
        li.appendChild(a);
        ul.insertBefore(li, ul.firstChild);
      });
    }
    var timer;
    function schedule() { clearTimeout(timer); timer = setTimeout(addShopAll, 60); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addShopAll); else addShopAll();
    window.addEventListener('load', addShopAll);
    document.addEventListener('click', schedule, true);
    try { new MutationObserver(function (list) { for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { schedule(); return; } } }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

})();
